import { useEffect, useRef, useState, createContext, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext({ user: null, checked: false, setUser: () => {} });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check — AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) {
      setChecked(true);
      return;
    }
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => {})
      .finally(() => setChecked(true));
  }, []);

  return <AuthContext.Provider value={{ user, checked, setUser }}>{children}</AuthContext.Provider>;
};

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        navigate("/dashboard", { state: { user: res.data }, replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <p className="font-mono2 text-sm text-slate-400">Signing you in securely...</p>
    </div>
  );
};

export const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const logout = async (setUser) => {
  await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }).catch(() => {});
  setUser(null);
};
